<template>
    <div class="json-header nested-card">
        <h4 class="mb-3">Headers</h4>
        <v-layout
            row
            class="delete-wrapper"
            v-for="(header, index) in headers"
        >
            <v-flex xs6>
                <label>Key</label>
                <v-text-field
                        outline
                        v-model="header.key"
                        :error="!header.key"
                        :error-messages="!header.key? 'Key is Required':'' "
                >
                </v-text-field>
            </v-flex>
            <v-flex xs6>
                <label>Value</label>
                <v-text-field
                        outline
                        v-model="header.value"
                        :error="!header.value"
                        :error-messages="!header.value? 'Value is Required':'' "
                >
                </v-text-field>
            </v-flex>
            <v-btn
                    @click="deleteHeader(index)"
                    fab small color=""
                    class="delete-button"
            ><v-icon small color="#666">delete_outline</v-icon></v-btn>
        </v-layout>
        <v-btn
                large round flat block
                class="primary--text"
                @click="addHeader"
        >
            <v-icon>add_circle_outline</v-icon>
            Add Header
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "json-header",
        props: {
            headers: {
                type: Array,
                default: ()=>{
                    return []
                }
            }
        },
        methods: {
            addHeader() {
                this.headers.push({
                    key:'',
                    value:''
                })
            },
            deleteHeader(index) {
                this.headers.splice(index, 1)
            }
        }
    }
</script>

<style scoped>

</style>